/**
 * シンタックスハイライト用カラー定義
 */
export type SyntaxColors = {
  comment: string;
  header: string;
  directive: string;
  motion: string;
  control: string;
  welding: string;
  condition: string;
  io: string;
  operation: string;
  variable: string;
  number: string;
  label: string;
  keyword: string;
  string: string;
};

/**
 * テーマに応じたシンタックスカラーを取得
 */
export const getSyntaxColors = (isDark: boolean): SyntaxColors =>
  isDark
    ? {
        // ダークモード（VS Code Dark+風）
        comment: '#6a9955',
        header: '#808080',
        directive: '#569cd6',
        motion: '#569cd6',
        control: '#c586c0',
        welding: '#ce9178',
        condition: '#d16969',
        io: '#4ec9b0',
        operation: '#dcdcaa',
        variable: '#9cdcfe',
        number: '#b5cea8',
        label: '#d7ba7d',
        keyword: '#c586c0',
        string: '#ce9178'
      }
    : {
        // ライトモード（VS Code Light+風）
        comment: '#008000',
        header: '#6a737d',
        directive: '#0000ff',
        motion: '#0000ff',
        control: '#af00db',
        welding: '#a31515',
        condition: '#a31515',
        io: '#267f99',
        operation: '#795e26',
        variable: '#001080',
        number: '#098658',
        label: '#811f3f',
        keyword: '#af00db',
        string: '#a31515'
      };
